
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_zr0a1_ppnio_5",
  "step-title": "awsui_step-title_zr0a1_ppnio_6"
};
  